module.exports = __webpack_public_path__ + "static/media/work_in_progress.baf41af7.jpg";